import { HeroTeaser as HeroTeaserShared } from '@vwfs-bronson/bronson-react';
import React, { MouseEventHandler } from 'react';
import { FocalPoint, ImageProps } from '@cp-shared-15/apis';

export type HeroImageProps = {
    className?: string;
    pretitle?: string;
    title: string | React.ReactNode;
    subTitle?: string | React.ReactNode;
    text?: string | React.ReactNode;
    imageUrl?: string;
    imageAlt?: string;
    buttonText?: string;
    buttonAriaLabel?: string;
    buttonTitle?: string;
    clickHandler?: MouseEventHandler;
    shallow?: boolean;
    inverted?: boolean;
    focalPoint?: FocalPoint;
    auto?: boolean;
    buttonIsHiddenOnLargeScreen?: boolean;
    testId?: string;
};

export const HeroImage: React.FC<HeroImageProps> = ({
    className,
    pretitle,
    title,
    subTitle,
    text,
    imageUrl,
    imageAlt,
    buttonText,
    buttonAriaLabel,
    buttonTitle,
    clickHandler,
    shallow,
    inverted,
    focalPoint,
    auto,
    buttonIsHiddenOnLargeScreen = false,
    testId,
}) => {
    const imgProps: ImageProps = { src: imageUrl, alt: imageAlt };

    return (
        <HeroTeaserShared
            className={className}
            pretitle={pretitle}
            title={title}
            sub={subTitle}
            imgProps={imgProps}
            buttonText={buttonText}
            buttonProps={{ ariaLabel: buttonAriaLabel ?? buttonText, title: buttonTitle ?? buttonText, type: 'button' }}
            onButtonClick={clickHandler}
            shallow={shallow}
            noImage={!imageUrl}
            inverted={!!inverted}
            topLeft={focalPoint === 'top-left'}
            topCenter={focalPoint === 'top-center'}
            topRight={focalPoint === 'top-right'}
            centerLeft={focalPoint === 'center-left'}
            centerRight={focalPoint === 'center-right'}
            bottomLeft={focalPoint === 'bottom-left'}
            bottomCenter={focalPoint === 'bottom-center'}
            bottomRight={focalPoint === 'bottom-right'}
            auto={auto}
            buttonIsHiddenOnLargeScreen={buttonIsHiddenOnLargeScreen}
            testId={testId}
        >
            {text}
        </HeroTeaserShared>
    );
};
